import { useEffect, useRef } from "react"

export function sig (arr) { 
    
	if (!Array.isArray(arr)) return 'invalid';
    
	return arr.length === 0
	? 'empty'
	: arr.map(r => `${r.id ?? '-'}:${r.pxoTableValues?.[0]?.value ?? '-'}`).join('|');
}

export function useRenderCount(componentName = "Componente") {
    
	const renderCount = useRef(1);
  
    useEffect(() => {

		if (renderCount.current === 1) {
			console.log(`${componentName} montou`);
		} else {
			console.log(`${componentName} renderizou ${renderCount.current}x`);
		}
		renderCount.current += 1;

    });
  }

export const normalizeTotals = (arr) =>
    (Array.isArray(arr) ? arr : [])
		.map(({ tableColumnId, value }) => ({
			tableColumnId: Number(tableColumnId),
			value: Number(value) || 0
		})).sort((a, b) => a.tableColumnId - b.tableColumnId)
  
export const sigTotals = (arr) =>
    normalizeTotals(arr).map(x => `${x.tableColumnId}:${x.value.toFixed(6)}`).join('|')



export const toSelectOptions = (list, valueKey = 'id', labelKey = 'name') =>

	list.map(item => ({
		...item,
		value: item[valueKey],
		label: item[labelKey]
	}));